import './caption-slider.scss';
import 'slick-carousel';
import AOS from 'aos';

export default () => {
	$( '.js-caption-slider' ).on( 'init', function ( event, slick ) {
		$( this ).append( '<div class="slick-counter"><span class="current"></span> / <span class="total"></span></div>' );
		$( '.current' ).text( slick.currentSlide + 1 );
		$( '.total' ).text( slick.slideCount );
	} )
		.slick( {
			rows: 0,
			infinite: true,
			slidesToShow: 1,
			arrows: true,
			dots: false,
			fade: true,
			autoplaySpeed: 5000,
			speed: 900,
			easing: 'easeOutSine',
			swipe: true,
			centerMode: true,
			centerPadding: '0px',
			prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="icon-arrow"></i></button>',
			nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="icon-arrow"></i></button>',
			responsive: [ {
				breakpoint: 639,
				settings: {
					centerMode: false,
				},
			} ],
		} )
		.on( 'beforeChange', function ( event, slick, currentSlide, nextSlide ) {
			$( '.current' ).text( nextSlide + 1 );
		} );

	AOS.init( {
		duration: 800,
		once: true,
	} );
};
